import { useEffect, useState } from 'react';

import isDeepEqual from 'lib/isDeepEqual';

export function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isDeepEqual(value, debouncedValue)) return;
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
    // we don't want to re-run this effect when the debounced value changes,
    // but we need to reference it to prevent infinite re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, delay]);

  return debouncedValue;
}
